import type { EmotionalState, LocalClassifierConfig, CognitiveState } from './types';
import { LocalEmotionClassifier } from './LocalEmotionClassifier';
// TODO: setup @mediapipe/tasks-genai/llminference when ready

export class Gemma3LocalClassifier {
  private localBase: LocalEmotionClassifier;

  constructor(config?: LocalClassifierConfig) {
    // fallback for now to existing local classifier while we integrate MediaPipe Gemma3 local inferencing.
    this.localBase = new LocalEmotionClassifier(config);
  }

  startCalibration(): void {
    this.localBase.startCalibration();
  }

  getIsCalibrating(): boolean {
    return this.localBase.getIsCalibrating();
  }

  async classify(
    blendshapes: Record<string, number>,
    landmarks?: Array<{ x: number; y: number; z: number; i?: number }>,
    headRotation?: { yaw: number; pitch: number; roll: number },
    handNearFace?: boolean
  ): Promise<EmotionalState | null> {
    // TODO: replace with actual Gemma-3 on-device inference.
    return this.localBase.classify(blendshapes, landmarks, headRotation, handNearFace);
  }

  getCognitiveState(
    landmarks?: Array<{ x: number; y: number; z: number; i?: number }>,
    blendshapes?: Record<string, number>,
    headRotation?: { yaw: number; pitch: number; roll: number }
  ): CognitiveState {
    return this.localBase.getCognitiveState(landmarks, blendshapes, headRotation);
  }

  setGazeCalibrationOffset(offset: { h: number; v: number } | null): void {
    this.localBase.setGazeCalibrationOffset(offset);
  }

  getGazeCalibrationOffset(): { h: number; v: number } | null {
    return this.localBase.getGazeCalibrationOffset();
  }

  setHeadCalibrationOffset(offset: { yaw: number; pitch: number } | null): void {
    this.localBase.setHeadCalibrationOffset(offset);
  }

  getHeadCalibrationOffset(): { yaw: number; pitch: number } | null {
    return this.localBase.getHeadCalibrationOffset();
  }

  setScreenCalibrationAnchor(anchor: { x: number; y: number } | null): void {
    this.localBase.setScreenCalibrationAnchor(anchor);
  }

  getScreenCalibrationAnchor(): { x: number; y: number } | null {
    return this.localBase.getScreenCalibrationAnchor();
  }

  reset(): void {
    this.localBase.reset();
  }
}
